import React from "react";
import clsx from "clsx";
import { useTranslation,  } from "react-i18next";
import {withRouter} from "react-router-dom";
import { isIOS, isMacOs } from 'react-device-detect'
import http from "../../../../http/http";
import URL from "../../../../constant/URL";

import { useUserInfo } from "../../../../hooks";
import { TYPE } from "../../../../constant";
import { func_animation } from "../../../../utils/utilityEtc";
import { A } from "../../../common";
import { useEffect } from "react";

let audio_Id = null;
const Guide =  withRouter((props) => {
  const { info } = useUserInfo();
  const { t, i18n } = useTranslation();
  const [talkIndex, setTalkIndex] = React.useState(0);
  const [talkClass, setTalkClass] = React.useState("talk_wrap ani_1");
  const [audioUrl, setAudioUrl] = React.useState("");
  const [talkText] = React.useState([
    t("LC_03_01.msg001").replace(/<br\/>/gi, " "),
    t("LC_03_01.msg002").replace(/<br\/>/gi, " "),
    t("LC_03_01.msg003").replace(/<br\/>/gi, " "),
    t("LC_03_01.msg004").replace(/<br\/>/gi, " "),
    t("LC_03_01.msg005").replace(/<br\/>/gi, " "),
    t("LC_03_01.msg006").replace(/<br\/>/gi, " "),
    // '안녕! AI 연산은 처음이지?',
    // '이제부터 나랑 같이 연산 공부를 할 거야.',
    // '네가 빠르고 정확하게 잘 풀면 문제 수가 줄어들어. 그러면 학습을 빨리 끝낼 수 있겠지?',
    // '하지만 딴짓을 하거나 장난을 치면 문제 수가 더 많이 늘어난다는 점 명심해!',
    // '대신 어려워서 못 풀 때는 내가 바로바로 도와줄게!',
    // '그럼, 이제 시작해 볼까?',
  ]);

  useEffect(() => {
    window.addEventListener("backgroundApp", (e) => {
      // console.log("##### backgroundApp : ", e);
      // ios 앱이 백그라운드 됐을 때 소리 재생 종료
      if (audio_Id) {
        audio_Id.pause();
        audio_Id.currentTime = 0;

        window.removeEventListener("backgroundApp", this);
      }
    });
  }, []);

  const moveNext = (e) => {
    e.stopPropagation();
    // let audio_Id = document.getElementById('audio_player');
    if (audio_Id) audio_Id.pause();
    props.history.replace({pathname : URL.COURSE_LEARNING.LIST,});
  };

  const changeTalkBox = () => {

    if(talkIndex < 6){
      mount(talkText[talkIndex]);
      setTalkClass(`talk_wrap ani_${talkIndex+1}`);
    }else{
      setTimeout(()=>{props.history.replace({pathname : URL.COURSE_LEARNING.LIST,})}, 3000);
    }

  };

  const mount = (txt) => {
    if(txt){
      http.request( {
        url : URL.API.TTS,
        type : http.TYPE.TTS,
        method : http.METHOD.POST,
        data : {
          speaker: i18n.language === 'ko' ? 'nhajun' : 'djoey',
          text : txt,
          volume : 0,
          speed : 0,
          pitch : 0,
          format : 'mp3',
        },
        success: (data) => {
          setAudioUrl(data);
        },
        error:(error) => {
          console.log("guide audio error: ", error);
        }
      });
    }
  };

  const renderAnimation = () => {
    const path = info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'cha_lc_aimessage_01' : 'ai_lc_03_01';
    func_animation(path, path, true);
  };

  const playAudio = () => {
    audio_Id = document.getElementById('audio_player');

    if (isIOS || isMacOs) {
      audio_Id = document.createElement('audio');
      audio_Id.setAttribute("id", "audio_player");
      // audio_Id.controls = true;
      // audio_Id.autoplay = true;
      // audio_Id.muted = true;
      // audio_Id.playsinline = true;

      const sourceElement = document.createElement('source');
      audio_Id.appendChild(sourceElement);
      sourceElement.src = audioUrl;
      sourceElement.type = 'audio/mpeg';

      try {
        audio_Id.load();
        audio_Id.play();
      } catch (error) {
        console.log({ error });
      }

    } else {
      var promise = document.querySelector('audio').play();
      if (promise !== undefined) {
        promise.then(() => {
          audio_Id.load();
          audio_Id.play();
        }).catch(error => {
          console.log("playAudio error: ", error);
        })
      }
    }
    
    audio_Id.onended = () => {
      setTalkIndex(talkIndex + 1);
    };
  };

  const renderAudio = (url) => {
    return(
      <audio src={url} id="audio_player"  autoPlay/>
    );
  };

  React.useEffect(() => {
    if (audioUrl) playAudio();
  }, [audioUrl]);
  React.useEffect(changeTalkBox, [talkIndex]);
  React.useEffect(renderAnimation, []);

  return (
    <div className={clsx("layout-def course_guide", info.className)}>
      <div className="container">
        <div className="inner">
          <div className="btn_area">
            <A className="skip" onClick={(e)=>moveNext(e)}><span>SKIP</span></A>
          </div>
          <div className={talkClass}>
            <section>
              <article>
                <span dangerouslySetInnerHTML={{__html: t("LC_03_01.msg001")}}/>
              </article>
            </section>
            <section>
              <article>
                <span dangerouslySetInnerHTML={{__html: t("LC_03_01.msg002")}}/>
              </article>
            </section>
            <section>
              <article>
                <span dangerouslySetInnerHTML={{__html: t("LC_03_01.msg003")}}/>
              </article>
            </section>
            <section>
              <article>
                <span dangerouslySetInnerHTML={{__html: t("LC_03_01.msg004")}}/>
              </article>
            </section>
            <section>
              <article>
                <span dangerouslySetInnerHTML={{__html: t("LC_03_01.msg005")}}/>
              </article>
            </section>
            <section>
              <article>
                <span dangerouslySetInnerHTML={{__html: t("LC_03_01.msg006")}}/>
              </article>
            </section>
          </div>
          {(!isIOS && !isMacOs) && renderAudio(audioUrl)}
          <div className="img_wrap1">
            <div className="cont">
              <div 
                className="anim-wrap" 
                id={TYPE.CHANNEL.GLOBAL01 === info.channelCode ? 'cha_lc_aimessage_01' : 'ai_lc_03_01'}
              />
            </div>
          </div>
          <div className={clsx(
            TYPE.CHANNEL.GLOBAL01 === info.channelCode ? 'img_wrap3' : 'img_wrap2'
          )} />
        </div>
      </div>
    </div>
  );

});

export default Guide;
